import { Outlet } from 'react-router-dom';
// @mui

// components


// ----------------------------------------------------------------------


// ----------------------------------------------------------------------

export default function SimpleLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}
